import HomeSections from "../HomeSections";
import usePageMeta from "../hooks/usePageMeta";
import EmbeddedNav from "../components/EmbeddedNav";

function IconShield() {
  return (
    <svg viewBox="0 0 24 24" className="h-5 w-5 text-slate-600" aria-hidden="true">
      <path d="M12 2.8 20 6v6c0 5.1-3.5 8.4-8 9.7-4.5-1.3-8-4.6-8-9.7V6l8-3.2Z" fill="currentColor" />
      <path d="m9.3 12.1 1.7 1.8 3.8-3.8" fill="none" stroke="#fff" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}

function IconClock() {
  return (
    <svg viewBox="0 0 24 24" className="h-5 w-5 text-slate-600" aria-hidden="true">
      <circle cx="12" cy="12" r="9" fill="none" stroke="currentColor" strokeWidth="1.8" />
      <path d="M12 7.5V12l3 2.4" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
    </svg>
  );
}

function IconWallet() {
  return (
    <svg viewBox="0 0 24 24" className="h-5 w-5 text-slate-600" aria-hidden="true">
      <rect x="2.5" y="6.5" width="19" height="11" rx="3" fill="currentColor" />
      <rect x="12" y="8.8" width="8.6" height="6.2" rx="2" fill="#fff" />
      <circle cx="17.2" cy="11.9" r="1.05" fill="currentColor" />
    </svg>
  );
}

export default function HomePage() {
  usePageMeta("Zebra MicroWealth | Home", "Fast, safe, and simple loans in South Africa.");

  return (
    <>
      <section id="home" className="relative w-full bg-slate-100">
        <img src="./assets/pinkbackground.png" alt="" aria-hidden="true" className="absolute inset-0 z-0 h-full w-full object-cover" />
        <div className="absolute inset-0 z-0 bg-[#f8f2f7]/80" />

        <div className="relative z-10 w-full px-6 py-8 md:px-10 lg:py-10">
          <EmbeddedNav />
          <div className="mt-8 grid items-center gap-8 lg:grid-cols-2 lg:gap-10">
            <div className="lg:pr-6">
              <h1 className="max-w-3xl text-5xl font-semibold leading-[1.06] tracking-tight text-slate-800 sm:text-6xl lg:text-7xl">
                Fast, Safe, and Simple Loans in South Africa
              </h1>

              <p className="mt-5 max-w-3xl text-2xl leading-[1.34] text-slate-600 lg:mt-6 lg:max-w-[820px] lg:text-3xl">
                Get quick personal loans from R1,000 to R2,000 with same-day review and simple repayment terms.
              </p>
              <p className="mt-3 max-w-3xl text-xl leading-[1.34] text-slate-700 lg:max-w-[820px] lg:text-2xl">
                Pay up to 5% interest and admin fees.
              </p>

              <div className="mt-6 lg:mt-8 lg:max-w-[420px]">
                <a
                  href="https://5577-8888.webfin.co.za/webloans/"
                  className="inline-flex w-full items-center justify-center whitespace-nowrap rounded-xl bg-gradient-to-b from-pink-400 to-pink-500 px-6 py-4 text-[clamp(1.5rem,1.8vw,2.25rem)] font-semibold text-white shadow-xl transition hover:brightness-90 focus-visible:outline-none focus-visible:ring-4 focus-visible:ring-pink-200 lg:rounded-2xl lg:py-5"
                >
                  Apply Now
                </a>
              </div>

              <div className="mt-6 flex flex-wrap items-center gap-x-6 gap-y-3 text-xl text-slate-600 lg:mt-8 lg:max-w-[960px] lg:flex-wrap lg:text-2xl">
                <span className="inline-flex items-center gap-2 whitespace-nowrap">
                  <IconShield />
                  Secure application
                </span>
                <span className="inline-flex items-center gap-2 whitespace-nowrap">
                  <IconClock />
                  Quick review
                </span>
                <span className="inline-flex items-center gap-2 whitespace-nowrap">
                  <IconWallet />
                  Transparent estimates
                </span>
                <span className="inline-flex items-center gap-2 whitespace-nowrap">
                  <IconWallet />
                  NCR regulated interest rates
                </span>
              </div>

              <div className="mt-6 w-full max-w-[620px] p-2 text-center md:p-3">
                <img src="/assets/ncr-logo.png" alt="NCR logo" className="mx-auto mb-4 h-32 w-auto md:h-40" />
                <p className="mx-auto mb-2 max-w-[520px] text-lg font-semibold leading-[1.3] text-slate-700 md:text-2xl">
                  Zebra MicroWealth is a registered credit provider. <span className="font-bold">NCRCP29302</span>
                </p>
                <p className="text-sm font-medium tracking-[0.08em] text-slate-500 md:text-base">
                  ZEBRA MICROWEALTH
                </p>
              </div>
            </div>

            <div className="relative min-h-[460px] sm:min-h-[560px] lg:min-h-[680px]">
              <div className="absolute right-4 top-10 z-10 h-[280px] w-[280px] rounded-full bg-pink-300/30 blur-2xl sm:h-[360px] sm:w-[360px] lg:right-10 lg:top-16 lg:h-[520px] lg:w-[520px]" />

              <img
                src="./assets/herocoupleimage.png"
                alt="Happy couple standing together and holding a phone"
                className="absolute right-0 top-6 z-20 max-h-[640px] w-auto object-contain sm:top-8 lg:top-2 lg:max-h-[640px]"
              />

              <div className="absolute bottom-4 left-1/2 z-30 w-[94%] max-w-[560px] -translate-x-1/2 rounded-3xl border border-white/60 bg-white/85 p-4 shadow-2xl backdrop-blur-md sm:bottom-6 sm:p-5 lg:bottom-4 lg:right-12 lg:left-auto lg:w-[520px] lg:translate-x-0">
                <div className="flex items-start gap-3 lg:gap-4">
                  <div className="grid h-14 w-14 shrink-0 place-items-center rounded-full bg-pink-100 sm:h-16 sm:w-16 lg:h-[84px] lg:w-[84px]">
                    <img src="./assets/pinkzebra.png" alt="" className="h-10 w-10 object-contain lg:h-14 lg:w-14" />
                  </div>
                  <div className="min-w-0 flex-1">
                    <div className="flex items-center justify-between gap-2">
                      <p className="truncate text-[26px] font-bold leading-none text-slate-800 lg:text-[34px]">Zebra MicroWealth</p>
                      <span className="text-xs tracking-[0.12em] text-slate-500 lg:text-sm">TOWY</span>
                    </div>
                    <p className="mt-1 text-[22px] leading-[1.25] text-slate-700 lg:text-[28px]">
                      You have received a transfer of <strong>R 2,000</strong> on your account.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <HomeSections />
    </>
  );
}
